import React, { Component, Fragment } from 'react'
import { Helmet } from 'react-helmet'
import { connect } from 'react-redux'
import { mapDispatchToProps } from '../../helpers/redux.helper'
import Select from 'antd/lib/select'
import ButtonNavigator from '../ButtonNavigator'
import { pages } from '../../utils/constants'
import Loader from '../Loader'
import './index.sass'
import { translate } from 'react-i18next'
import Breadcrumbs from '../Breadcrumbs'
import ScrollUpButton from '../ScrollUpButton'

const { Option } = Select

class Pricing extends Component {
  state = {
    lang: 'british english',
  }

  fixDropDownMenu = e => {
    if (!e.target.className.includes('ant-select-dropdown-menu')) {
      this.onDropDownVisibleChange(false)
    }
  }

  onDropDownVisibleChange = value => {
    this.setState({
      isDropDownVisible: value,
    })
  }

  componentWillUnmount() {
    window.removeEventListener('scroll', this.fixDropDownMenu)
  }

  componentDidMount = () => {
    window.addEventListener('scroll', this.fixDropDownMenu, true)
    const {
      pricing,
      actions: { getPricing },
    } = this.props

    if (Object.keys(pricing).length === 0) {
      getPricing()
    }
  }

  onHandleChange = value => {
    this.setState({
      lang: value.toLowerCase(),
    })
  }

  getPriceNumber = stringValue => {
    const splittedPrice = stringValue.split(' ')
    if (+splittedPrice[1]>170) {
      splittedPrice[1] = +splittedPrice[1]-170
    }
    return splittedPrice.join(' ')
  }

  render = () => {
    const { lang } = this.state
    const { pricing, loading, lng, t, actions: { changeModalVisibility, toggleVisibleAudioPlayer, setPlayingStatus, setChoosenVoice } } = this.props
    return (
      <Fragment>
        <Helmet>
          <html lang={lng} />
          <title>{t('prices.title')}</title>
          <link rel="alternate" hrefLang="en"
              href="https://unimedia.io/prices" />
          <link rel="alternate" hrefLang="de"
              href="https://unimedia.io/de/prices" />
          <link rel="alternate" hrefLang="ru"
              href="https://unimedia.io/ru/prices" />
          <link rel="alternate" hrefLang="x-default"
              href="https://unimedia.io/prices" />
          <meta
            name="description"
            content={t('prices.description')}
          />
          {lng === 'en' ? <link rel="canonical" href={'https://unimedia.io/prices'} /> : <link rel="canonical" href={`https://unimedia.io/${lng}/prices`} />}
          <meta property="og:title" content={t('prices.title')} />
          <meta property="og:description" content={t('prices.description')} />
          <meta property="og:image" content="https://unimedia.io/assets/logo.svg" />
          <meta property="og:url" content={lng === 'en' ? 'https://unimedia.io/prices': `https://unimedia.io/${lng}/prices`} />
          <script type="application/ld+json">
          {`[{
              "@context" : "https://schema.org/",
              "@type": "Product",
              "name": "${t('productDescription')}",
              "image": "https://unimedia.io/assets/logo.svg",
              "description": "${t('prices.description')}",
              "brand": {
                "@type": "Brand",
                "name": "Universal Media"
              },
              "aggregateRating": {
                "@type": "AggregateRating",
                "ratingValue": "4.8",
                "bestRating": "5",
                "reviewCount": "5"
              }
            },
            {
                "@context": "https://schema.org",
                "@type": "Organization",
                "name": "Universal Media",
                "alternateName": "Unimedia",
                "url": "https://unimedia.io",
                "logo": "https://unimedia.io/assets/logo.svg"
            },
            {
              "@context": "https://schema.org",
              "@type": "BreadcrumbList",
              "itemListElement": [{
                "@type": "ListItem",
                "position": 1,
                "name": "${t('navigations.home')}",
                "item": "https://unimedia.io"
              },{
                "@type": "ListItem",
                "position": 2,
                "name": "${t('navigations.prices')}"
              }]
            }]`}
          </script>
        </Helmet>
        <ScrollUpButton id={'pricing'} />
        <div className="pricing-page container overflow-y" id={'pricing'}>
          <div className="container-wrapper">
          <div className='breadcrumbs'>
            <Breadcrumbs pathname={window.location.pathname}/>
          </div>
            <h1>{t('prices.subtitle')}</h1>
            {loading ? (
              <Loader />
            ) : (
              <Fragment>
                <div className="price-select">
                  <p className="subtitle-2">{t('prices.selectLanguage')}</p>
                  {Object.keys(pricing).length > 0 && (
                    <Select
                      defaultValue={lang}
                      onChange={this.onHandleChange}
                      filterOption={(input, option) =>
                        option.props.value.toLowerCase().indexOf(input.toLowerCase()) >= 0
                      }
                      showSearch
                    >
                      {Object.keys(pricing).map((country, index) => (
                        <Option key={index} value={country} className="price-option">
                          <span className="price-option-value">{t(`Language.${country.split(' ')
      .map(s => s.charAt(0).toUpperCase() + s.substring(1))
      .join(' ')}`)}</span>
                        </Option>
                      ))}
                    </Select>
                  )}
                </div>
                <div className="price-info">
                  {Object.keys(pricing).length > 0 &&
                    pricing[lang].map((elem, ind) => (
                      <div className="info-price-item" key={ind}>
                        <p className="info-price-name body-light">{elem.name
                        .replace('words Price per minute', t('prices.partlyTranslations.words price per minute'))
                        .replace('up to', t('prices.partlyTranslations.up to'))
                        .replace('words', t('prices.partlyTranslations.words'))
                        .replace('min', t('prices.partlyTranslations.min'))
                        .replace('Over 1 hour', t('prices.partlyTranslations.Over 1 hour'))}</p>
                        <span className="dashed"></span>
                        <p className="info-price subtitle-2">{this.getPriceNumber(elem.price)}</p>
                      </div>
                    ))}
                </div>
                <div className='pricingText'>
                <p>{t('prices.texts.0')}</p>
                <p>{t('prices.texts.1')}</p>
                  {lng === 'en'?
                  <p>It is also important to understand that commercial rights for usage in Internet or broadcast rights for radio/TV, etc. will require extra cost. These rates are calculated individually. In order to find out the final cost of our voice over services for your product, please  <span className='greatText' onClick={()=>{changeModalVisibility(true);setPlayingStatus(false); toggleVisibleAudioPlayer(false);setChoosenVoice('translating')}}>leave us a request</span> for quotation, and we will help you to implement your project and find the perfect blend of price/quality.</p>
                  : lng === 'ru' ?
                  <span>Также важно понимать, что стоимость указана для частного пользования, без учета коммерческих прав на размещение в интернете или прав на широковещание на радио/тв. Данные тарифы рассчитываются индивидуально. Для того, чтобы узнать финальную стоимость наших услуг для Вашего продукта, просто <span className='greatText' onClick={()=>{changeModalVisibility(true);setPlayingStatus(false); toggleVisibleAudioPlayer(false);setChoosenVoice('translating')}}>оставьте нам запрос</span> на расчет, и мы поможем реализовать Ваш проект и найти идеальное сочетание цены/качества.</span>
                  : <span>Es ist auch wichtig zu verstehen, dass die Preise für den privaten Gebrauch gelten und keine kommerziellen Internet- oder Radio-/TV-Übertragungsrechte enthalten. Diese Preise werden individuell berechnet. Um die endgültigen Kosten unserer Dienstleistungen für Ihr Produkt zu erfahren, <span className='greatText' onClick={()=>{changeModalVisibility(true);setPlayingStatus(false); toggleVisibleAudioPlayer(false);setChoosenVoice('translating')}}>senden Sie uns</span> einfach eine Anfrage für eine Kalkulation, und wir helfen Ihnen, Ihr Projekt zu realisieren und die perfekte Preis-Leistung Kombination zu finden.</span>
                  }
                </div>
                <ButtonNavigator
                  route={`${pages.VOICES}/${lang.split(' ').join('-')}`}
                  description={t('prices.showVoices')}
                  isArrowInside={true}
                />
              </Fragment>
            )}
          </div>
        </div>
      </Fragment>
    )
  }
}

const mapStateToProps = state => ({
  pricing: state.pricing,
  loading: state.app.loading,
  actions: state.actions,
})

export default translate('translations')(connect(
  mapStateToProps,
  mapDispatchToProps
)(Pricing))
